import {APIProvider} from '@vis.gl/react-google-maps';
import {Box, Show} from 'platform/foundation';

import {useState} from 'react';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {TestDriveRouteMapContent} from './components/TestDriveRouteMapContent';

type TestDriveRouteMapProps = TestIdProps & {
  /** Google encoded polyline recorded by the CarAudit app during the test drive. */
  encodedRoute: string | Nullish;
};

/**
 * The animated route of the test drive. A drive without a recorded route, or a map that cannot
 * load, leaves the section as it was before routes were recorded.
 */
export function TestDriveRouteMap(props: TestDriveRouteMapProps) {
  const [hasLoadError, setHasLoadError] = useState(false);
  const googleApiKey = process.env.GOOGLE_API_KEY ?? '';

  const isMapAvailable = isNotNilOrEmpty(googleApiKey) && !hasLoadError;

  return (
    <Show when={isMapAvailable && isNotNilOrEmpty(props.encodedRoute) ? props.encodedRoute : null}>
      {(encodedRoute) => (
        <Box data-testid={props['data-testid']}>
          <APIProvider apiKey={googleApiKey} onError={() => setHasLoadError(true)}>
            <TestDriveRouteMapContent
              encodedRoute={encodedRoute}
              data-testid={suffixTestId('map', props)}
            />
          </APIProvider>
        </Box>
      )}
    </Show>
  );
}
